import { buyerRouteFactory } from './index';
import { ASSIGNMENT } from 'sh-www/models/assignment';

export default buyerRouteFactory(ASSIGNMENT.STATUS.DRAFT, '/postings/draft/');
